import {FormComponent} from "../components/FormComponent";
import {FormGroup} from "../components/FormComponent/FormGroup";
import React from "react";

export class NewPasswordPage extends FormComponent {

    protected getRequestUrl(): RequestInfo | URL {
        return '/new-password';
    }

    protected onSuccess(data: any) {
        (document.querySelector('form .alert-success') as HTMLElement).classList.remove('hide');
    }

    protected onError(error: any) {
        (document.querySelector('form .alert-danger') as HTMLElement).innerHTML = this.dictionary.get[error.message];
        (document.querySelector('form .alert-danger') as HTMLElement).classList.remove('hide');
    }

    protected handleSubmit(event: any) {
        if (!(document.querySelector('form .alert-success') as HTMLElement).classList.contains('hide')) {
            (document.querySelector('form .alert-success') as HTMLElement).classList.add('hide');
        }
        if (!(document.querySelector('form .alert-danger') as HTMLElement).classList.contains('hide')) {
            (document.querySelector('form .alert-danger') as HTMLElement).classList.add('hide');
        }
        super.handleSubmit(event);
    }

    render() {

        const hash: string = window.location.pathname.split('/').pop() || '';

        return (
            <div className="login-page">
                <div>
                    <div className="col-11 col-sm-9 col-md-7 col-lg-5 col-xl-4 col-xxl-3">
                        <form onSubmit={this.handleSubmit}>
                            <h3>{this.dictionary.get['set-new-password']}</h3>

                            <input type={'hidden'} value={hash} name={'password_request'}/>

                            <FormGroup.Input {...{
                                id: 'email',
                                name: 'username',
                                type: 'email',
                                help: 'email-anyone',
                                autoComplete: 'username',
                                placeholder: this.dictionary.get['email']
                            }}/>
                            <FormGroup.Input {...{
                                id: 'password',
                                name: 'password',
                                required: true,
                                type: 'password',
                                help: 'min-8-char',
                                placeholder: this.dictionary.get['password'],
                                autoComplete: this.dictionary.get['new-password']
                            }}/>
                            <FormGroup.Input {...{
                                id: 'passwordRe',
                                name: 'passwordRe',
                                required: true,
                                type: 'password',
                                placeholder: this.dictionary.get['password'],
                                autoComplete: this.dictionary.get['new-password']
                            }}/>

                            <div className="form-group">
                                <button type="submit"
                                        className="btn btn-primary">{this.dictionary.get['set-new-password']}</button>

                                <a style={{
                                    textDecoration: 'none', float: 'right',
                                    top: '9px',
                                    position: 'relative',
                                    fontSize: '14px'
                                }}
                                   href={'/'}>{this.dictionary.get['login']}</a>
                            </div>

                            <div className="alert alert-danger hide" role="alert">
                                {this.dictionary.get['unknown-error']}
                            </div>
                            <div className="alert alert-success hide" role="alert">
                                {this.dictionary.get['success-new-password']}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    };
}
